module.exports = __webpack_public_path__ + "img/iq.3ca43ad4.svg";